module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDIyIDMwIiBmaWxsPSIjQkNCQ0JDIj4KICAgIDxwYXRoIGQ9Ik0xNC41IDcuNXYtN2w3IDdoLTd6bTcuMzUtLjM1bC03LTdjLS4xLS4xLS4yMi0uMTUtLjM1LS4xNUguNUMuMjIgMCAwIC4yMiAwIC41djI5YzAgLjI3LjIyLjUuNS41aDIxYy4yOCAwIC41LS4yMy41LS41di0yMmMwLS4xMy0uMDUtLjI2LS4xNS0uMzV6Ij48L3BhdGg+Cjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./resources/images/icn-contracts.svg
// module id = 1713
// module chunks = 0